import Button from './Button';

type Props = {
  onAddText: () => void;
  onAddImage: () => void;
  onAddLink: () => void;
};

export default function AddElementBar({
  onAddText,
  onAddImage,
  onAddLink,
}: Props) {
  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full margin-top-2">
      <div className="flex justify-between items-center">
        <h3>Element hinzufügen</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button iconName="icon-edit" onClick={onAddText}>
          Textabschnitt
        </Button>
        <Button iconName="icon-photo-landscape" onClick={onAddImage}>
          Bild
        </Button>
        <Button iconName="icon-link" onClick={onAddLink}>
          Link einfügen
        </Button>
      </div>
    </div>
  );
}
